import { pathOr } from 'ramda'

export const getRatingProductForm = state =>
  pathOr([], ['ratings', 'ratingProductForm'], state)

export const getProducts = state => pathOr([], ['ratings', 'products'], state)

export const getCurrentProductId = state =>
  pathOr([], ['ratings', 'currentProductId'], state)

export const getShowReasonsFeedbackError = state =>
  pathOr([], ['ratings', 'showReasonsFeedbackError'], state)

export const isLoadingRatingProduct = state =>
  pathOr(null, ['ratings', 'isLoading'], state)
